module.exports = __webpack_public_path__ + "static/media/logo-dekton.a718be4d.svg";